export default __webpack_public_path__ + "static/media/icon_user.a2ba34a9.svg";